<ng-container *ngIf="error$ | async as errorMsg; else result">
  <em-error-result [subTitle]="errorMsg"></em-error-result>
</ng-container>

<ng-template #result>
  <div>
    <div nz-row>
      <div class="content-top">
        <nz-skeleton
          [nzActive]="true"
          [nzParagraph]="{ rows: 2 }"
          [nzLoading]="(isLoading$ | async) ?? false"
          [nzAvatar]="{ size: 'large', shape: 'square' }"
        >
          <em-design-data [design]="(design$ | async) ?? undefined"></em-design-data>
        </nz-skeleton>
      </div>
    </div>
    <div nz-row class="content-wrapper gutter">
      <div class="content-bottom">
        <nz-tabs class="em-tabs-full-width" nzLinkRouter>
          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'general' }"
              queryParamsHandling="merge"
            >
              General
            </a>

            <em-general-information
              [design]="(design$ | async) ?? undefined"
              [error]="(error$ | async) ?? ''"
              [loading]="(isLoading$ | async) ?? false"
              *emVisibleForRoles="[
                'Front End',
                'Novelty',
                'Re-Engineering',
                'Reorder',
                'Mould Engineering'
              ]"
            ></em-general-information>
          </nz-tab>

          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'planning' }"
              queryParamsHandling="merge"
            >
              Planning
            </a>

            <em-element-status
              *emVisibleForRoles="['Front End', 'Novelty', 'Mould Engineering']"
            ></em-element-status>
            <em-development-novelty-table
              *emVisibleForRoles="['Novelty', 'Re-Engineering', 'Mould Engineering']"
            ></em-development-novelty-table>
            <em-development-milestones-frontend-table
              *emVisibleForRoles="['Front End', 'Reorder']"
            ></em-development-milestones-frontend-table>
            <em-planning-report *emVisibleForRoles="['Reorder']"></em-planning-report>
          </nz-tab>

          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'materials' }"
              queryParamsHandling="merge"
            >
              Materials
              <em-warning-icon *ngIf="materialsValidationFails$ | async"></em-warning-icon>
            </a>

            <nz-row nzGutter="8" class="em-area">
              <nz-col nzSpan="24">
                <em-material-bom
                  *emVisibleForRoles="[
                    'Front End',
                    'Novelty',
                    'Re-Engineering',
                    'Reorder',
                    'Mould Engineering'
                  ]"
                ></em-material-bom>
              </nz-col>
            </nz-row>

            <nz-row nzGutter="8" class="em-area">
              <nz-col nzSpan="24">
                <em-units-of-measure
                  *emVisibleForRoles="['Front End', 'Novelty', 'Re-Engineering', 'Reorder']"
                ></em-units-of-measure>
              </nz-col>
            </nz-row>

            <nz-row nzGutter="8" class="em-area">
              <nz-col nzSpan="24">
                <em-material-colour-table
                  *emVisibleForRoles="[
                    'Front End',
                    'Novelty',
                    'Re-Engineering',
                    'Reorder',
                    'Mould Engineering'
                  ]"
                ></em-material-colour-table>
              </nz-col>
            </nz-row>

            <nz-row nzGutter="8" class="em-area">
              <nz-col nzSpan="24">
                <em-material-where-used-table
                  class="em-area"
                  *emVisibleForRoles="['Novelty', 'Reorder', 'Front End']"
                ></em-material-where-used-table>
              </nz-col>
            </nz-row>
          </nz-tab>
          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'specifications' }"
              queryParamsHandling="merge"
            >
              Specifications
              <em-warning-icon *ngIf="specificationValidationFails$ | async"></em-warning-icon>
            </a>
            <nz-row class="em-area">
              <nz-col nzSpan="24">
                <em-technical-specification
                  class="em-area"
                  *emVisibleForRoles="[
                    'Front End',
                    'Novelty',
                    'Re-Engineering',
                    'Reorder',
                    'Mould Engineering'
                  ]"
                ></em-technical-specification>
              </nz-col>
            </nz-row>
            <nz-row class="em-area">
              <nz-col nzSpan="24">
                <em-control-specification
                  class="em-area"
                  *emVisibleForRoles="[
                    'Front End',
                    'Novelty',
                    'Re-Engineering',
                    'Reorder',
                    'Mould Engineering'
                  ]"
                ></em-control-specification>
              </nz-col>
            </nz-row>
            <nz-row class="em-area">
              <nz-col nzSpan="24">
                <em-technical-review
                  class="em-area"
                  *emVisibleForRoles="['Novelty', 'Front End']"
                ></em-technical-review>
              </nz-col>
            </nz-row>
            <nz-row class="em-area">
              <nz-col nzSpan="24">
                <em-eco-table></em-eco-table>
              </nz-col>
            </nz-row>
          </nz-tab>

          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'element-log' }"
              queryParamsHandling="merge"
            >
              Element Log
            </a>

            <em-element-log
              *emVisibleForRoles="[
                'Front End',
                'Novelty',
                'Re-Engineering',
                'Reorder',
                'Mould Engineering'
              ]"
            ></em-element-log>
          </nz-tab>

          <nz-tab (nzClick)="adobeTrackingTabChangeWithSubTab(activeSubTab)">
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'teamcenter' }"
              queryParamsHandling="merge"
            >
              Teamcenter
            </a>
            <em-teamcenter
              (setActiveTab)="adobeTrackingTabChangeWithSubTab($event)"
              *emVisibleForRoles="[
                'Front End',
                'Novelty',
                'Re-Engineering',
                'Reorder',
                'Mould Engineering'
              ]"
            ></em-teamcenter>
          </nz-tab>

          <nz-tab>
            <a
              *nzTabLink
              nz-tab-link
              [routerLink]="['.']"
              [queryParams]="{ tab: 'equipment' }"
              queryParamsHandling="merge"
            >
              Equipment
            </a>

            <em-equipment
              *emVisibleForRoles="['Novelty', 'Mould Engineering', 'Front End']"
            ></em-equipment>
          </nz-tab>
        </nz-tabs>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noData>
  <nz-empty [nzNotFoundContent]="description"></nz-empty>
  <ng-template #description>
    <p>No design data.</p>
    <p>Please use the search bar to lookup a Design.</p>
  </ng-template>
</ng-template>
